export const FREE_SONG_CAP = 5;
export const FREE_REQUEST_BLOCK_MINS = 10;

export const TIER_FEATURES = {
  free: [
    'public_page',
    'gig_pipeline',
    'live_requests',
  ],
  pro: [
    'public_page',
    'gig_pipeline',
    'live_requests',
    'analytics',
  ],
  band: [
    'public_page',
    'gig_pipeline',
    'live_requests',
    'analytics',
    'bookings',
    'availability',
    'member_roles',
  ],
};

export const TIER_LABELS = {
  free: 'Starter',
  pro: 'Pro',
  band: 'Band',
};
